import { useEffect, useState } from "react";

import PinUi from "./PinUi";

const ApplicationPin = () => {
  const [isNotLaptop, setIsNotLaptop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const screenWidth = window.innerWidth;

      const isLaptop = screenWidth >= 1024;

      setIsNotLaptop(!isLaptop);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return <>{isNotLaptop && <PinUi />}</>;
};

export default ApplicationPin;
